import { useEffect, useRef } from 'react';


//@author Francisco Rubens
// restartKey restarts the countdown without making callback identity an interval dependency.
const useInterval = (callback: () => void, delay: number, extraDelay?: number, restartKey?: unknown) => {
    const savedCallback = useRef<() => void | null>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                if (extraDelay) {
                    setTimeout(() => {
                        if (savedCallback.current) {
                            savedCallback.current();
                        }
                    }, extraDelay);
                } else {
                    savedCallback.current();
                }
            }
        }

        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay, extraDelay, restartKey]);
};

export default useInterval;
